<template>
  <!-- The Modal -->
  <div class="modal" :class="!isShowModal ? 'hide' : 'show'">
    <!-- Modal content -->
    <div class="modal-content">
      <span class="close" @click="hideModal"></span>
      <div class="register">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="auth-block">
              <div class="form-label-block">
                <div class="title">
                  <h1>{{ $t('Authorization') }}</h1>
                  <div class="help-text">
                    {{ $t('auth_title_help_text') }}
                  </div>
                </div>
              </div>
              <div class="email-block social-block" :class="isShowEmailBlock ? 'active' : 'inactive'">
<!--                <a class="login-bnt-google" :href="authGoogleUrl" v-if="authGoogleUrl">-->
<!--                  <svg width="18" height="17"-->
<!--                       xmlns="http://www.w3.org/2000/svg"-->
<!--                       xmlns:xlink="http://www.w3.org/1999/xlink"-->
<!--                       viewBox="0 0 48 48">-->
<!--                    <defs><path id="a" d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24-->
<!--                    37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6-->
<!--                    4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"/>-->
<!--                    </defs>-->
<!--                    <clipPath id="b"><use xlink:href="#a" overflow="visible"/>-->
<!--                    </clipPath>-->
<!--                    <path clip-path="url(#b)" fill="#FBBC05" d="M0 37V11l17 13z"/>-->
<!--                    <path clip-path="url(#b)" fill="#EA4335" d="M0 11l17 13 7-6.1L48 14V0H0z"/>-->
<!--                    <path clip-path="url(#b)" fill="#34A853" d="M0 37l30-23 7.9 1L48 0v48H0z"/>-->
<!--                    <path clip-path="url(#b)" fill="#4285F4" d="M48 48L17 24l-4-3 35-10z"/>-->
<!--                  </svg>-->
<!--                  {{ $t('Google') }}-->
<!--                </a>-->
<!--                <a class="login-bnt-google" :href="authFacebookUrl" v-if="authFacebookUrl">-->
<!--                  <svg width="35" height="35"-->
<!--                      enable-background="new 0 0 512 512"-->
<!--                       id="Layer_1" version="1.1"-->
<!--                       viewBox="0 0 512 512"-->
<!--                       xml:space="preserve"-->
<!--                       xmlns="http://www.w3.org/2000/svg"-->
<!--                       xmlns:xlink="http://www.w3.org/1999/xlink">-->
<!--                    <linearGradient gradientTransform="matrix(1 0 0 -1 -41.66 349.04)"-->
<!--                                    gradientUnits="userSpaceOnUse"-->
<!--                                    id="f_1_" x1="213.2162" x2="363.2099"-->
<!--                                    y1="198.8942" y2="48.9005">-->
<!--                      <stop offset="0" style="stop-color:#3B5998"/><stop offset="1" style="stop-color:#336699"/>-->
<!--                    </linearGradient>-->
<!--                    <path d="M277.41,400.519V272.058h42.82l10.705-53.525H277.41v-21.41-->
<!--                    c0-21.41,10.726-32.115,32.115-32.115h21.41v-53.525c-10.705,0-23.98,0-42.82,0c-39.341,0-64.23,30.841-64.23,74.935v32.115h-42.82-->
<!--                    v53.525h42.82v128.46L277.41,400.519L277.41,400.519z" fill="url(#f_1_)" id="f_9_"/>-->
<!--                  </svg>-->
<!--                  {{ $t('Facebook') }}-->
<!--                </a>-->
              </div>
              <div class="phone-block" :class="isShowPhoneBlock ? 'active' : 'inactive'">
                <form @submit.prevent="onSubmit" autocomplete="off" >
                  <div :hidden="isCodeSend" class="mb-3">
                    <div class="phone-label">
                      <label for="phone" class="form-label">{{ $t('PhoneNumber') }}</label>
                      <div class="form-check form-check-right">
                        <input class="form-check-input" type="checkbox" id="isPhoneOtherCountry"
                               v-model="isPhoneOtherCountry">
                        <label class="form-check-label" for="isPhoneOtherCountry">
                          {{ $t('AnotherCountry') }}
                        </label>
                      </div>
                    </div>
                    <div class="form-input">
                      <input type="text"
                             name="phone"
                             class="form-control input-dirty" :class="!isPhoneOtherCountry ? 'show' : 'hide'"
                             placeholder="+38 (___) ___-__-__"
                             id="phone"
                             v-model="phone"
                             aria-describedby="phone"
                             :disabled="isSubmitting"
                      >
                      <input type="text"
                             name="raw_phone"
                             class="form-control input-dirty" :class="isPhoneOtherCountry ? 'show' : 'hide'"
                             placeholder="+____________"
                             id="raw_phone"
                             v-model="raw_phone"
                             aria-describedby="raw_phone"
                             :disabled="isSubmitting"
                      >
                      <div class="form-text" :class="isPhoneInvalid ? 'danger' : 'normal'">{{ phoneMsg }}</div>
                    </div>
                  </div>
                  <div :hidden="!isCodeSend" class="form-input mb-3">
                    <label for="code" class="form-label">{{ $t('Code') }}</label>
                    <input type="text"
                           name="code"
                           class="form-control input-dirty"
                           placeholder="______"
                           id="code"
                           v-model="code"
                           aria-describedby="code"
                           :disabled="isSubmitting"
                    >
                    <div class="form-text" :class="isCodeInvalid ? 'danger' : 'normal'">{{ codeMsg }}</div>
                  </div>
                  <div class="mt-4">
                    <button class="btn btn-success btn-danger" :disabled="isSubmitting">{{ $t('Continue') }}</button>
                  </div>
                </form>
                <span class="hr-offset">{{ $t('or') }}</span>
                <div class="login-bnt" @click="showEmailBlock">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="evenodd"
                       class="bi bi-box-arrow-in-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0
                    1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5
                    2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"/>
                    <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293
                    7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
                  </svg>
                  {{ $t('Email') }}
                </div>
              </div>
              <div class="email-block" :class="isShowEmailBlock ? 'active' : 'inactive'">
                <div class="login-bnt" @click="showPhoneBlock">
                  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.61711 14.336L12.2478 11.7053L16.5953 14.7374L15.6201 15.7127C14.9705 16.3622 14.017 16.6032
                    13.1367 16.3403C10.4457 15.5364 8.02832 14.0625 5.88456 11.9188C3.74081 9.77504 2.26698 7.35765
                    1.46307 4.66663C1.2001 3.7864 1.44109 2.83285 2.09069 2.18325L3.06594 1.20801L6.0981
                    5.55552L3.46738 8.18624" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  {{ $t('Phone') }}
                </div>
                <span class="hr-offset">{{ $t('or') }}</span>
                <form class="email-login" @submit.prevent="onSubmitEmail">
                  <div class="form-group required">
                    <label class="control-label" for="loginform-email">{{ $t('Email') }}</label>
                    <input type="email" id="email" name="email" v-model="email">
                    <p class="emailMsg danger">{{ emailMsg }}</p>
                  </div>
                  <div class="form-group required">
                    <label class="control-label" for="password">{{ $t('Password') }}</label>
                    <input type="password" id="password" class="password" name="password" v-model="password">
                    <p class="passwordMsg danger">{{ passwordMsg }}</p>
                  </div>
                  <button type="submit" class="btn btn--accent btn--full">{{ $t('Signin') }}</button>
                </form>
                <div class="signup-block">
                  <div class="help-text">
                    {{ $t('signup-help-text') }}
                  </div>
                  <a class="btn btn--not-accent" href="/dashboard/signup">
                    {{ $t('Signup') }}
                  </a>
                  <div v-if="isContinue" class="btn btn--not-accent btn--black mt-5" @click="hideModal">
                    {{ $t('ContinueWithoutAuthorization') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Inputmask from "inputmask";
  import {apiUrlWithLang} from "@/helpers/persistanceStorage";
  import axios from "@/api/axios";

  export default {
    name: 'ModalLoginAuth',
    data() {
      return {
        isShowModal: false,
        csrf: document.getElementById('appModalLogin').dataset.csrf,
        authGoogleUrl: document.getElementById('appModalLogin').dataset.authGoogleUrl,
        authFacebookUrl: document.getElementById('appModalLogin').dataset.authFacebookUrl,
        phone: '',
        raw_phone: '',
        isPhoneOtherCountry: false,
        code: '',
        email: '',
        password: '',
        emailMsg: '',
        passwordMsg: '',
        isShowPhoneBlock: false,
        isShowEmailBlock: true,
        isSubmitting: false,
        isPhoneInvalid: false,
        isCodeInvalid: false,
        isCodeSend: false,
        phoneMsg: this.$t("EnterYourPhoneNumber"),
        codeMsg: this.$t("EnterCodeFromSms"),
        authToken: null,
        isLoggedIn: false,
        isContinue: false,
      };
    },
    mounted() {
      this.$nextTick(function () {
        let phoneSelector = document.getElementById("phone");
        if (JSON.stringify(phoneSelector) !== "null"){
          let maskPhone = new Inputmask({ mask: "+38 (999) 999-99-99", greedy: false})
          maskPhone.mask(phoneSelector)
        }
        let codeSelector = document.getElementById("code");
        if (JSON.stringify(codeSelector) !== "null"){
          let maskCode = new Inputmask({ mask: "999999", greedy: false})
          maskCode.mask(codeSelector)
        }
      })
    },
    methods: {
      hideModal(){
        this.isShowModal = false
      },
      showModal(){
        this.isShowModal = true
      },
      onSubmit() {
        if (this.codeClean === ''){
          // Ony for phone enter
          if (!this.isPhoneOtherCountry && this.phoneClean.length < 12) {
            this.isPhoneInvalid = true;
          } else {
            // Send code for phone
            // this.$store.dispatch(actionTypes.sendCode, {phone: this.phoneClean, csrf: this.csrf})
            console.log("Send phone for get code")
            const credentials = {phone: this.phoneClean, csrf: this.csrf}

            this.isPhoneInvalid = false
            this.isSubmitting = true
            this.phoneMsg = ''

            const sendCode = credentials => {
              let url = apiUrlWithLang('/dashboard/api/login/send_code');
              return axios.post(url, credentials)
            }
            return new Promise(resolve => {
              sendCode(credentials)
                  .then(response => {
                      this.isSubmitting = false
                      console.log('response:', response)

                      if (response.data['results']['action'] === 'send_sms_code' &&
                          response.data['results']['status'] === 'ok'){

                          console.log("Send sms code is OK!")
                          this.isCodeSend = true

                          resolve(response.data['results'])
                      }
                  })
                  .catch(result => {
                      this.isSubmitting = false
                      console.log('Result Errors:', result)
                      if (result.response === undefined){
                          this.phoneMsg = 'Something wrong. Please reload this page or try late.'
                          this.isPhoneInvalid = true
                      } else {
                          console.log(result.response.data)

                          if (result.response.data['errors']['code']){
                              if (result.response.data['errors']['code'] == "permission_denied"){
                                  this.phoneMsg = 'The session has expired, please refresh the page.'
                                  this.isPhoneInvalid = true
                              }
                          }
                          if (result.response.data['errors']['non_field_errors']){
                              let msg = result.response.data['errors']['non_field_errors'][0]['message']
                              this.phoneMsg = msg
                              this.isPhoneInvalid = true
                          }
                      }
                  })
              })

          }
        } else if (this.codeClean.length < 6){
          this.isCodeInvalid = true;
        } else {
          // Auth by phone sms code
          console.log("Send sms code")
          const credentials = {phone: this.phoneClean, code: this.codeClean, csrf: this.csrf}

          this.isPhoneInvalid = false
          this.isSubmitting = true
          this.phoneMsg = ''

          const authByCode = credentials => {
              let url = apiUrlWithLang('/dashboard/api/login')
              return axios.post(url, credentials)
          }

          return new Promise(resolve => {
            authByCode(credentials)
                .then(response => {
                    this.isSubmitting = false
                    console.log('response:', response)

                    this.isCodeSend = false
                    this.codeMsg = ''
                    this.isLoggedIn = true
                    this.authToken = `Token ${response.data['token']}`

                    console.log("Auth Success")
                    if (response.data['token'] !== undefined && response.data['token'] !== ''){
                      this.hideModal()
                      this.$swal.fire({
                        title: this.$t('Successfully'),
                        text: this.$t('youHaveSuccessfullyLoggedIn'),
                        icon: "success",
                        showDenyButton: false,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: this.$t('ok'),
                      }).then(() => {
                          location.reload()
                      });
                    }

                    resolve(response.data)
                })
                .catch(result => {
                    this.isSubmitting = false
                    console.log('Result Errors:', result)
                    console.log(result.response.data)

                    if (result.response === undefined){
                        this.codeMsg = 'Something wrong. Please reload this page or try late.'
                        this.isCodeInvalid =true
                    } else {
                        let msg = result.response.data['errors']['non_field_errors'][0]['message']
                        this.codeMsg = msg
                        this.isCodeInvalid = true
                    }
                })
            })
        }
      },
      onSubmitEmail() {
        // Auth by email
        console.log("Auth by email")

        this.emailMsg = ''
        this.passwordMsg = ''

        this.isPhoneInvalid = false
        this.isSubmitting = true
        this.phoneMsg = ''

        const credentials = {email: this.email, password: this.password}

        const authByEmail = credentials => {
            let url = apiUrlWithLang('/dashboard/api/login/email')
            return axios.post(url, credentials)
        }

        return new Promise(resolve => {
            authByEmail(credentials)
                .then(response => {
                    this.isSubmitting = false
                    console.log('response:', response)

                    this.isLoggedIn = true
                    this.authToken = `Token ${response.data['token']}`

                    console.log("Auth Success")
                    if (response.data['token'] !== undefined && response.data['token'] !== ''){
                      this.hideModal()
                      this.$swal.fire({
                        title: this.$t('Successfully'),
                        text: this.$t('youHaveSuccessfullyLoggedIn'),
                        icon: "success",
                        showDenyButton: false,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: this.$t('ok'),
                      }).then(() => {
                          location.reload()
                      });
                    }
                    resolve(response)
                })
                .catch(result => {
                    this.isSubmitting = false
                    console.log('Result Errors:', result)
                    if (
                        result.response.status === 401
                        || result.response.status === 403
                        || result.response.data.errors.code === "authentication_failed"
                    ){
                        console.log("Need re-auth.")
                        location.reload()
                    }
                    if (
                      result.response.data['errors']['non_field_errors'] !== undefined &&
                      result.response.data['errors']['non_field_errors'][0]['code'] === "authorization"){
                      this.passwordMsg = result.response.data['errors']['non_field_errors'][0]['message']
                    }
                    if (result.response.data['errors']['email'] !== undefined){
                      this.emailMsg = result.response.data['errors']['email'][0]['message']
                    }
                    if (result.response.data['errors']['password'] !== undefined){
                      this.passwordMsg = result.response.data['errors']['password'][0]['message']
                    }
                    resolve(result.response)
                })
            })
      },
      showPhoneBlock(){
        this.isShowEmailBlock = false
        this.isShowPhoneBlock = true
      },
      showEmailBlock(){
        this.isShowEmailBlock = true
        this.isShowPhoneBlock = false
      }
    },
    computed: {
      phoneClean(){
        let phone = ''
        let phone_str = this.phone
        if (this.isPhoneOtherCountry){
          phone_str = this.raw_phone
        }
        let phoneItems = phone_str.match(/[0-9]+/g)
        if (phoneItems === null) {
          return ''
        }
        phoneItems.forEach(function(i) {
          phone += i;
        })
        return phone
      },
      codeClean(){
        let code = ''
        let codeItems = this.code.match(/[0-9]+/g)
        if (codeItems === null) {
          return ''
        }
        codeItems.forEach(function(i) {
          code += i;
        })
        return code
      }
    },
    watch: {
      isShowModal: function (val) {
        if (val === true) {
          document.body.classList.add('no-scroll')
        } else {
          document.body.classList.remove('no-scroll');
        }
      }
    },
  };
</script>

<style scoped lang="scss">
  @import "@/scss/variables.scss";
  @import "@/scss/mixins.scss";

  .hide{
    display: none !important;
  }
  .show{
    display: block !important;
  }
  .modal {
    display: none;
    position: fixed;
    z-index: 9;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
  }

  .modal-content {
    position: relative;
    background-color: #fefefe;
    margin: 10% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 400px;
    @media only screen and (max-width: $max-width-mobile) {
      margin: 15% auto;
      width: 90%;
    }
  }

  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    z-index: 9;
    user-select: none;
    position: absolute;
    right: 16px;
    top: 16px;
    width: 32px;
    height: 32px;
    opacity: 0.3;
  }

  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
  .close:before, .close:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 33px;
    width: 2px;
    background-color: #333;
  }
  .close:before {
    transform: rotate(45deg);
  }
  .close:after {
    transform: rotate(-45deg);
  }

  .register {
    overflow-x: hidden;
    padding: 4px;
    .title {
      margin-bottom: 10px;
      user-select: none;
      .help-text{
        margin-top: 10px;
        margin-bottom: 15px;
        font-size: 13px;
        color: $fi;
        max-width: 380px;
      }
    }
    .form-label-block{
      display: flex;
      flex-direction: column
    }
    .description{
      margin-bottom: 40px;
    }
    .form-phone-block{
      display: flex;
    }
    .login-block{
      display: flex;
      flex-direction: column;
      padding-top: 30vh;
      padding-bottom: 50px;
      padding-left: 100px;
      padding-right: 225px;
      height: 100vh;
      background-color: $bd-y-gray;
      @media only screen and (max-width: $max-width-laptop) {
        padding-left: 50px;
        padding-right: 100px;
        height: unset;
      }
      @media only screen and (max-width: $max-width-tablet) {
        padding-top: 30px;
      }
      @media only screen and (max-width: $max-width-mobile) {
        padding-top: 30px;
        padding-left: 10px;
        padding-right: 10px;
      }
      .info-asterisk-container{
        display: flex;
        font-size: 14px;
      }
      .btn{
        max-width: 280px;
      }
      ul {
          display: block;
          list-style-type: disc;
          margin-block-start: 1em;
          margin-block-end: 1em;
          margin-inline-start: 0px;
          margin-inline-end: 0px;
          padding-inline-start: 40px;
      }
      ul li {
        font-size: 14px;
        line-height: 18px;
        padding-bottom: 10px;
      }
      ul li:before {
          background: $danger;
          content: "";
          display: block;
          height: 8px;
          left: 0;
          position: absolute;
          top: 4px;
          width: 2px;
      }
    }
    #phone, #password {
      max-width: 200px;
    }

    .danger {
      color: $danger;
    }

    .normal {
      color: $fd;
    }
    .email-block{
      display: flex;
      flex-direction: column;
      @media only screen and (max-width: $max-width-mobile) {
        width: unset;
      }
      .login-bnt{
        margin: 0 0 16px;
        background: $bd-y-gray-dark;
        border: 0;
        border-radius: 3px;
        cursor: pointer;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
        user-select: none;
      }
      .login-bnt:hover{
        color: $fi;
        svg{
          opacity: .5;
        }
      }
      .login-bnt-google{
        color: $fd;
        margin: 0 0 16px;
        background: white;
        border: 1px solid $bd-y-gray-dark;
        border-radius: 3px;
        cursor: pointer;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
        text-decoration: none;
        user-select: none;
      }
      .login-bnt-google:hover{
        color: $fi;
        background: $bd-y-gray-dark;
        svg{
          opacity: .5;
        }
      }
      .btn{
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        border: 0;
        border-radius: 3px;
        cursor: pointer;
        display: inline-block;
        font-family: DIN\ 2014,sans-serif;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
        transition: color .3s ease;
        width: 100%;
        -webkit-appearance: none;
        background: $btn-cart;
        color: $bg-100;
        user-select: none;
      }
      .btn--not-accent {
        background: 0 0;
        border: 1px solid #333;
        transition: color .3s ease;
        color: #333;
      }
      .btn--not-accent:hover{
        border: 1px solid #333;
        color: rgba(51, 51, 51, 0.53);
      }
      .btn--black{
        background: $black-75;
        color: #fff;
      }
      .btn--black:hover{
        background: 0 0;
      }
    }
    .social-block{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 10px;
      .login-bnt-google {
        flex-basis: calc(50% - 5px)
      }
    }
    .signup-block{
      margin-top: 20px;
      .help-text{
        font-size: 13px;
        color: $fi;
        max-width: 380px;
      }
    }
    .phone-block{
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      form{
        padding-bottom: 20px;
      }
      .login-bnt{
        margin: 0 0 16px;
        background: $bd-y-gray-dark;
        border: 0;
        border-radius: 3px;
        cursor: pointer;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
      }
      .btn{
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        border: 0;
        border-radius: 3px;
        cursor: pointer;
        display: inline-block;
        font-family: DIN\ 2014,sans-serif;
        height: 50px;
        line-height: 50px;
        padding: 0;
        text-align: center;
        transition: color .3s ease;
        width: 100%;
        -webkit-appearance: none;
        background: $btn-cart;
        color: $bg-100;
      }
      .btn-danger{
        background: $danger;
      }
      .form-input {
        input {
          line-height: 1;
          padding: 0 40px 0 16px;
          outline: none;
          display: block;
          width: 100%;
          appearance: none;
          background: #fbf8f8;
          border: 1px solid transparent;
          border-radius: 3px;
          font-family: DIN\ 2014, sans-serif;
          height: 40px;
          transition: border .3s ease;
          max-width: unset !important;
        }
      }
      .form-check-right{
      display: flex;
      justify-content: right;
      label{
        padding-left: 8px;
      }
    }
    .phone-label{
      display: flex;
      justify-content: space-between;
      font-weight: 200;
    }
  }
  .inactive{
    display: none !important;
  }
  .active{
    display: flex;
  }
  .hr-offset{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-weight: 600;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    line-height: 18px;
    margin: 0 0 16px;
    user-select: none;
  }
  .hr-offset:after, .hr-offset:before {
    margin: 0 10px;
    background: $bd-y-gray-dark;;
    content: "";
    display: block;
    height: 1px;
    width: calc(100% - 12px);
  }
  .form-group {
    margin: 0 0 24px;
    position: relative;

    .control-label {
      color: $fi;
      display: block;
      font-size: 12px;
      line-height: 9px;
      margin: 0 0 8px;
    }

    input {
      line-height: 1;
      padding: 0 40px 0 16px;
      outline: none;
      display: block;
      width: 100%;
      appearance: none;
      background: #fbf8f8;
      border: 1px solid transparent;
      border-radius: 3px;
      font-family: DIN\ 2014, sans-serif;
      height: 40px;
      transition: border .3s ease;
      max-width: unset !important;
    }
  }
  }

  img, svg {
    vertical-align: middle;
  }

  label {
    font-weight: 200;
  }

  .form-check-input {
    margin-top: 2px;
    width: 17px;
    height: 17px;
    border-radius: 4px;
    border: 1px solid #ced4da;
    background-color: white;
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    position: relative;
  }

  .form-check-input:checked[type=checkbox] {
    background-color: #007bff;
    border-color: #007bff;
    --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e");
    background-image: var(--bs-form-check-bg-image);
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .form-check-input:hover {
    border-color: #90caf9;
  }
  .form-check-input:focus {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }

</style>